<template>
	<div class="list list--my-resources list-my-resources">
		<card
			class="list-my-resources__item"
			:key="`my_${key}`"
			:class="item.access"
			v-for="(item, key) in resources"
		>
			<div class="list-my-resources__item-alist" v-if="item.access == 'alist'">
				A-List
			</div>
			<div class="list-my-resources__item-logo">
				<img :src="item.logo" v-if="item.logo" />
				<ion-icon :name="item.icon" v-if="item.icon" />
			</div>
			<div class="list-my-resources__item-title" v-html="item.name"></div>
			<div class="list-my-resources__item-description" v-html="item.access == 'alist' && item.descriptionAlt && !accessList.alist ? item.descriptionAlt : item.description"></div>
			<div class="list-my-resources__item-tag" v-if="item.status == 'beta'">beta</div>
			<template v-if="accessList.alist && item.access == 'alist'">
				<router-link class="list-my-resources__item-link" :to="{name: 'resourceView', params: { resourceId: item.resourceId}}" v-if="item.type == 'embedded'">View Resource</router-link>
				<a :href="item.url" rel="noopener" class="list-my-resources__item-link" :target="item.resourceId ? '_self' : '_blank'" v-else>View Resource</a>
			</template>
			<template v-else-if="item.access == 'alist'">
				<router-link :to="{name: 'alist', params: { resourceId: item.resourceId }}" class="list-my-resources__item-link">MEMBERS ONLY - LEARN MORE</router-link>
			</template>
			<template v-else>
				<router-link class="list-my-resources__item-link" :to="{name: 'resourceView', params: { resourceId: item.resourceId}}" v-if="item.type == 'embedded'">View Resource</router-link>
				<a :href="item.url" rel="noopener" class="list-my-resources__item-link" :target="item.resourceId ? '_self' : '_blank'" v-else>View Resource</a>
			</template>
		</card>

	</div>
</template>

<script>
import Card from '@/components/Card'
import { ResourceAccess, ResourceType } from '@/lib/enums'

export default {
	name: 'listResources',
	components: {
		Card,
	},
	props: {
		access: Boolean,
		resources: Array,
		user: Object,
		accessList: Object,
	},
	data: () => ({
		ResourceType,
		ResourceAccess,
	}),
	methods: {
		requestPrompt(app) {
			this.$confirm(`Would you like us to send you more information about ${app.name}?`, () => {
				this.$store.dispatch('resource/requestInfo', app.resourceId)
					.then((res) => {
						this.$notice(`Thank you! Someone will be in touch shortly.`)
					})
					.catch((error) => {
						this.$notice(`ERROR: ${error.message || error}`)
					})
					.finally(() => {

					})
			}, {
				title: `Request More Info`,
				acceptLabel: `Yes, Send`,
			})
		},
	},
}
</script>

<style scoped lang="scss">
@use '@material/elevation';

.list-my-resources {
	@include modules.gutter('grid-column-gap');
	@include modules.gutter('grid-row-gap');

	display: grid;
	grid-template-columns: repeat(2, 1fr);

	@include modules.media-query('phone') {
		grid-template-columns: 1fr;
	}

	@include modules.media-query('tablet') {
		grid-template-columns: repeat(2, 1fr);
	}

	@include modules.media-query-min-width('desktop-sm') {
		grid-template-columns: repeat(4, 1fr);
	}

	&__item {
		// @include elevation.elevation(20, rgba(0, 0, 0, 0.15), -0.1);
		@include modules.gutter('padding-top');

		align-items: center;
		border-radius: modules.$border-radius-lg;
		display: flex;
		flex-direction: column;

		&.alist {
			background-color: modules.color_('primary');
			color: modules.color_('primary','text');
			border: 1px solid modules.color_('secondary');
			outline: 1px solid rgba(modules.color_('secondary'), 0.5);
			outline-offset: -0.5rem;
		}

		&-logo {
			@include modules.gutter('margin-bottom', .25);
			ion-icon {
				color: modules.color_('primary');
				@include modules.fontSize(70px);

				.alist & {
					color: modules.color_('secondary');
				}
			}

			img {
				height: 70px;
				width: 70px;
				color: modules.color_('primary');

				.alist & {
					color: modules.color_('secondary');
				}
			}
		}

		&-title {
			@include modules.gutter('padding-left');
			@include modules.gutter('padding-right');
			@include modules.fontSize(24px);
			font-weight: 500;
			line-height: 1.35;
			text-align: center;
		}

		&-tag {
			@include modules.fontSize(12px);
			background-color: modules.color_('primary');
			border-radius: 3px;
			color: modules.color_('primary', 'text');
			padding: 2px 6px;
			position: absolute;
			right: 1rem;
			text-transform: uppercase;
			top: 1rem;
		}

		&-description {
			@include modules.gutter('padding');
			@include modules.gutter('padding-top', .5);
			color: modules.color_('text');
			flex: 1;
			@include modules.fontSize(15px);
			line-height: 1.5;
			text-align: center;

			.alist & {
				color: modules.color_('text','light');
			}
		}

		&-link {
			border-top: 1px solid rgba(modules.color_('border'), 0.5);
			color: modules.color_('primary');
			@include modules.fontSize(14px);
			font-weight: 600;
			letter-spacing: 2.2px;
			text-align: center;
			text-decoration: none;
			text-transform: uppercase;
			transition: all 150ms linear;
			padding: 1.5rem;
			width: 100%;

			&:hover {
				color: modules.color_('primary', 'light');
			}

			.alist & {
				border-color: rgba(modules.color_('secondary'), 0.5);
				color: modules.color_('secondary');
			}
		}

		&-alist {
			color: modules.color_('secondary');
			font-style: italic;
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: 0.35rem;
			margin: 0 0 0.75rem 0;

			&:before,
			&:after {
				content: '';
				display: block;
				height: 1px;
				width: 1.5rem;
				background-color: modules.color_('secondary');
			}

		}
	}
}
</style>
